var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 621,
    height: 516,
    viewBox: "0 0 621 516",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 93L322 1L418.5 40L262.5 101L172 136L171.75 181.875L171.625 204.812L171.594 210.547L338 148V212L171.25 273.625L171.5 227.75L171 319.5C246.582 342.538 287 372.5 310.5 421V487C257.611 411.854 214.055 381.314 96 360.5V93Z",
    fill: "url(#paint0_linear_8_141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 93L322 1L418.5 40L262.5 101L172 136L171.75 181.875L171.625 204.812L171.594 210.547L338 148V212L171.25 273.625L171.5 227.75L171 319.5C246.582 342.538 287 372.5 310.5 421V487C257.611 411.854 214.055 381.314 96 360.5V93Z",
    fill: "url(#paint1_linear_8_141)",
    fillOpacity: 0.96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 93L322 1L418.5 40L262.5 101L172 136L171.75 181.875L171.625 204.812L171.594 210.547L338 148V212L171.25 273.625L171.5 227.75L171 319.5C246.582 342.538 287 372.5 310.5 421V487C257.611 411.854 214.055 381.314 96 360.5V93Z",
    fill: "url(#paint2_linear_8_141)",
    fillOpacity: 0.96
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M171.001 319.322L96 360.452V93L172 136L171.75 181.875L171.625 204.812L171.25 273.625L171.5 227.75L171.001 319.322Z",
    fill: "url(#paint3_linear_8_141)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M361 160L407 140V286.5C388.982 295.692 378.959 301.301 361 314.793V160Z",
    fill: "url(#paint4_linear_8_141)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M423 111L469 91V260C450.854 266.897 440.799 270.977 423 278.5V111Z",
    fill: "url(#paint5_linear_8_141)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M536.5 30C548.374 30 558 39.6259 558 51.5C558 63.3741 548.374 73 536.5 73C532.735 73 529.197 72.0313 526.119 70.3311C525.229 69.9656 524.194 69.5255 523 69L499 85V235C499 240.5 492.5 247 487 251V79.2607L516.802 60.126C515.644 57.4854 515 54.568 515 51.5C515 39.6259 524.626 30 536.5 30ZM537 39C530.373 39 525 44.3726 525 51C525 57.6274 530.373 63 537 63C543.627 63 549 57.6274 549 51C549 44.3726 543.627 39 537 39Z",
    fill: "url(#paint6_linear_8_141)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M524 273.688C523.868 274.735 523.618 275.755 523.289 276.742C517.657 300.788 506.068 312.745 482.194 326.726L481.5 327.5C400.5 355 338 397 311 487V422C323 358 378.753 318.306 418.5 300C438.514 290.782 457.566 282.957 473.567 276.899C497.296 266.642 511.495 252.649 514 230.431V163.5H524V273.688Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M553.5 111C565.374 111 575 120.626 575 132.5C575 144.374 565.374 154 553.5 154C548.244 154 543.429 152.113 539.694 148.981C539.573 149.31 539.5 149.5 539.5 149.5L523.966 161V169H514C514 169 514 166.5 514 160C514 153.534 521.422 150.035 533.807 141.138C532.645 138.494 532 135.573 532 132.5C532 120.626 541.626 111 553.5 111ZM553 121C546.373 121 541 126.373 541 133C541 139.627 546.373 145 553 145C559.627 145 565 139.627 565 133C565 126.373 559.627 121 553 121Z",
    fill: "url(#paint7_linear_8_141)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 326L72.5897 331C74 344.5 69.8312 363.924 83 372C98.5 378 134.5 382.5 166 394C197.5 405.5 224.587 418.601 261.5 448.5C271.839 458.53 278.015 466.252 288 478C227 431 142 398 45.0372 396L25.5 326Z",
    fill: "url(#paint8_linear_8_141)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M331 477C370 387 486 332.5 596.5 326L575.5 395.5C472.77 393.999 397 417 330 478.5L331 477Z",
    fill: "url(#paint9_linear_8_141)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 420C58.4617 415.141 93.1884 416.868 157 431C218.367 447.025 250.999 465.24 308 512L309 513.5C235.5 472 137.538 457.791 30.5 469.5L1.5 420Z",
    fill: "url(#paint10_linear_8_141)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M620 420C563.038 415.141 528.312 416.868 464.5 431C403.133 447.025 370.501 465.24 313.5 512L312.5 513.5C386 472 483.962 457.791 591 469.5L620 420Z",
    fill: "url(#paint11_linear_8_141)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M96 360.454L171 319.5C246.582 342.538 287 372.5 310.5 421V487C257.611 411.854 214.055 381.314 96 360.5V360.454Z",
    fill: "url(#paint12_linear_8_141)",
    fillOpacity: 0.8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M524 273.688C523.868 274.735 523.618 275.755 523.289 276.742C517.657 300.788 506.068 312.745 482.194 326.726L481.5 327.5C400.5 355 338 397 311 487V422C323 358 378.753 318.306 418.5 300C438.514 290.782 457.566 282.957 473.567 276.899C497.296 266.642 511.495 252.649 514 230.431V163.5H524V273.688Z",
    fill: "url(#paint13_linear_8_141)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M309.5 418.824L312 424L311.5 484.5L311 487L310.5 487L309.5 484.5V418.824Z",
    fill: "url(#paint14_linear_8_141)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8_141",
    x1: 364.5,
    y1: 20,
    x2: 182,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955237,
    stopColor: "#092562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8_141",
    x1: 196.5,
    y1: 85.5,
    x2: 96,
    y2: 122.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#092562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2560"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8_141",
    x1: 335,
    y1: 178,
    x2: 96,
    y2: 268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A2560"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8_141",
    x1: 134.174,
    y1: 93,
    x2: 134.174,
    y2: 360.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#082461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00205B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8_141",
    x1: 384,
    y1: 140,
    x2: 384,
    y2: 314.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAAB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454954,
    stopColor: "#D89808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C28002"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8_141",
    x1: 446,
    y1: 91,
    x2: 446,
    y2: 278.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4B719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#E0A10D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C78503"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8_141",
    x1: 522.5,
    y1: 30,
    x2: 522.5,
    y2: 251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1B41F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495192,
    stopColor: "#F3B517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB8811"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8_141",
    x1: 544.5,
    y1: 111,
    x2: 544.5,
    y2: 169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0173E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#016DE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8_141",
    x1: 39,
    y1: 361.5,
    x2: 288,
    y2: 467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002668"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480769,
    stopColor: "#00449F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8_141",
    x1: 330,
    y1: 402.25,
    x2: 596.5,
    y2: 402.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0847AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8_141",
    x1: 1.5,
    y1: 465.525,
    x2: 309,
    y2: 465.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001E5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001C53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8_141",
    x1: 620,
    y1: 465.525,
    x2: 312.5,
    y2: 465.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001E57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001E55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8_141",
    x1: 140.5,
    y1: 336.5,
    x2: 311,
    y2: 444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#001F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00225E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8_141",
    x1: 513.5,
    y1: 270,
    x2: 283.567,
    y2: 349.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026EE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8_141",
    x1: 343.75,
    y1: 454,
    x2: 277.75,
    y2: 454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#012461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02235F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.f8345d664da1ff94e1322209a9d28667.svg";
export { ForwardRef as ReactComponent };